<template>
  <div id="expense-detail-actual-shipment-list" class="panel-body">
    <expense-detail-table
      :url="'/Delivery/expense-detail/actual-shipment'"
      :extraUrl="[]"
      :method="'get'"
      :clientMode="false"
      :columns="$options.columns"
      :isSearchable="true"
      :searchValue="keyword"
      @countData="countData = $event"
      :needExtraData="true"
      @extraData="extraData = $event"
      @keyword="onHandleSearch"
      @confirmDownloadCsv="openModalConfirmDownloadCsv"
      ref="expenseDetailActualShipmentTable"
    >
      <template slot="shippingDate" slot-scope="props">
        <span>{{ formatDate(props.rowData.shippingDate) }}</span>
      </template>
      <template slot="detail" slot-scope="props">
        <div v-html="props.rowData.detail" class="mr-r-5"></div>
      </template>
      <template slot="size" slot-scope="props">
        <span>{{ sizeName(props.rowData.size) }}</span>
      </template>
      <template slot="costNoTax" slot-scope="props">
        <span>{{ formatAmount(props.rowData.costNoTax) }}</span>
      </template>
      <template slot="cost" slot-scope="props">
        <span>{{ formatAmount(props.rowData.cost) }}</span>
      </template>
    </expense-detail-table>

    <modal-confirm-download-csv
      v-if="showModalConfirmDownloadCsv"
      :message="`セルモン倉庫の費用明細（出荷実績）CSVをダウンロードします。<br> よろしければ「ダウンロード」ボタンを押してください。`"
      @close="closeModalConfirmDownloadCsv"
      @downloadCsv="handleDownloadCsv"
    />
  </div>
</template>

<script>
import moment from 'moment'
import ExpenseDetailTable from './ExpanseDetailTable.vue'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import ModalConfirmDownloadCsv from '@/view/deliveryRequests/components/ModalConfirmDownloadCsv.vue'
import DeliveryService from '@/services/deliveryservice'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    ExpenseDetailTable,
    ModalConfirmDownloadCsv
  },
  data () {
    return {
      keyword: null,
      search: null,
      showModalConfirmDownloadCsv: false,
      filters: {
        detail: null,
        from: null,
        to: null
      }
    }
  },
  columns: [
    {
      title: '出荷確定日時',
      name: 'shippingDate',
      cellClass: '',
      headerClass: 'text-center w-200'
    },
    {
      title: '明細',
      name: 'detail',
      cellClass: '',
      headerClass: 'text-center header-detail'
    },
    {
      title: '配送サイズ',
      name: 'size',
      cellClass: '',
      headerClass: 'text-center w-150'
    },
    {
      title: '運賃等合計(税抜)',
      name: 'costNoTax',
      cellClass: 'text-right',
      headerClass: 'text-center w-150'
    },
    {
      title: '運賃等合計(税込)',
      name: 'cost',
      cellClass: 'text-right',
      headerClass: 'text-center w-150'
    }
  ],
  mounted () {
    let self = this
    this.$events.listen('apiSuccess', (url) => {
      if (url === '/Delivery/expense-detail/actual-shipment') {
        self.loader && self.loader.hide()
      }
    })
    if (this.currentTab && this.currentTab === 'expense-detail-actual-shipment') {
      let logParams = {
        name: eventCode.delivery_requests.expense_detail_actual_shipment_tab.show,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    }
  },
  methods: {
    formatAmount (value) {
      return `¥${Util.formatMoney(value)}`
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD HH:mm:ss') : null
    },
    onHandleSearch (keyword) {
      let logParams = {
        name: eventCode.delivery_requests.expense_detail_actual_shipment_tab.click_search_button,
        properties: keyword
      }
      EventService.postTrackLog(logParams)

      this.filters = keyword
    },
    sizeName (size) {
      let sizeName = null
      let arrSize = {
        '30': 'ネコポス',
        '60': '60サイズ',
        '80': '80サイズ',
        '100': '100サイズ',
        '120': '120サイズ',
        '140': '140サイズ',
        '160': '160サイズ',
        '180': '180サイズ',
        '200': '200サイズ'
      }
      sizeName = arrSize[size]
      return sizeName
    },
    async handleDownloadCsv () {
      let logParams = {
        name: eventCode.delivery_requests.expense_detail_actual_shipment_tab.click_download_csv_button,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      let sellerId = this.$store.getters.getUser.sellerId
      let reportTime = moment(new Date()).format('YYYYMMDDHHmmss')
      let filename = `salmonWarehouse_shippingCost_${sellerId}_${reportTime}.csv`
      let params = {
        sellerId: sellerId,
        detail: this.filters.detail,
        from: this.filters.from,
        to: this.filters.to,
        costType: 'shippingCost'
      }

      this.closeModalConfirmDownloadCsv()
      await DeliveryService.postExport(params, filename)
        .then(response => {
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    openModalConfirmDownloadCsv () {
      this.showModalConfirmDownloadCsv = true
    },
    closeModalConfirmDownloadCsv () {
      $('#confirm-download-cvs-modal').modal('hide')
      this.showModalConfirmDownloadCsv = false
    }
  }
}
</script>

<style scoped>
@media (max-width: 1200px) {
  #expense-detail-actual-shipment-list /deep/ .table-wrapper {
    width: 100%;
    overflow-y: hidden;
    overflow-x: auto;
  }
  #expense-detail-actual-shipment-list /deep/ .table {
    width: max-content;
    max-width: max-content;
  }
  #expense-detail-actual-shipment-list /deep/ .header-detail {
    width: 500px;
  }
  #expense-detail-actual-shipment-list /deep/ .box-base-table-search {
    display: block;
    justify-content: unset;
    align-items: unset;
    flex-wrap: unset;
  }
  #expense-detail-actual-shipment-list /deep/ .box-base-table-search .sale-detail-search {
    display: block;
  }
  #expense-detail-actual-shipment-list /deep/ .box-base-table-search .search-block {
    display: block;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/deliveryRequests/ExpenseDetailActualShipment.vue